import HeroTransparent from './modules/HeroTransparent.js';
import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';
import NavModals from './modules/NavModals.js';
import VideoButton from './modules/Video.js';
import Categories from './modules/Categories.js';
import MediaText from './modules/MediaText.js';
import HomeModal from './modules/HomeModal.js';

document.addEventListener('DOMContentLoaded', function() {
  HeroTransparent();
  Navigation();
  MobileNavigation();
  NavModals();
  VideoButton();
  Categories();
  MediaText();
  HomeModal();

  // trickery to make core latest posts button to match design
  // Function to check window width and perform the button movement if needed
  function checkWidthAndMoveButtons() {
    // Only proceed if window width is less than 782px
    if (window.innerWidth < 782) {
      // Find all .wp-block-query elements on the page
      const queryBlocks = document.querySelectorAll('.wp-block-query');
      
      // If there are any query blocks, process each one
      if (queryBlocks.length > 0) {
        queryBlocks.forEach(function(queryBlock) {
          // Find all h3 elements within this query block
          const h3Elements = queryBlock.querySelectorAll('h3');
          
          h3Elements.forEach(function(h3) {
            // Check if the next sibling is a .wp-block-buttons div
            let nextSibling = h3.nextElementSibling;
            
            if (nextSibling && nextSibling.classList.contains('wp-block-buttons')) {
              // Found a buttons div after an h3
              const buttonsDiv = nextSibling;
              
              // Find the ul.wp-block-post-template within the same query block
              const postTemplate = queryBlock.querySelector('ul.wp-block-post-template');
              
              if (postTemplate) {
                // Move the buttons div to after the post template
                postTemplate.after(buttonsDiv);
              }
            }
          });
        });
      }
    }
  }
  
  // Initial check when the page loads
  checkWidthAndMoveButtons();
  
  // Also check when the window is resized
  window.addEventListener('resize', checkWidthAndMoveButtons);

});
